import { render } from "./EventDetail.vue?vue&type=template&id=5746402f"
import script from "./EventDetail.vue?vue&type=script&lang=ts"
export * from "./EventDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script